import { JSX } from 'react';
import { SidePhotoContentCard } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { GetSidePhotoContentCardModel } from './C13SidePhotoContentCard.service';
import { C13SidePhotoContentCardProps } from './C13SidePhotoContentCard.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { getCheckbox } from 'src/shared/param-utils';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C13SidePhotoContentCardProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <SidePhotoContentCard
      verticalSpacing
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
      {...GetSidePhotoContentCardModel({ props, isEditing: sitecoreContext?.pageEditing || false })}
    />
  );
};

export default checkDatasourceForRendering<C13SidePhotoContentCardProps>(Default);
